import React, { useState, useEffect, FormEvent } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "@/assets/css/style.css";
import { useAppSelector } from "@/store/hooks";

const TagForm: React.FC = () => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const { token } = useAppSelector((state) => state.auth);

  // Fetch tag details if editing
  useEffect(() => {
    if (id) {
      fetch(`${baseUrl}/tags/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((res) => res.json())
        .then((data) => {
            console.log('Fetched tag data:', data);
          if (data.status && data.data) {
            setName(data.data.name || "");
            setDescription(data.data.description || "");
          }
        })
        .catch((err) => console.error("Failed to load tag:", err));
    }
  }, [id, baseUrl, token]);

  // Submit handler
  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = { name, description };

      const url = id
        ? `${baseUrl}/tags/${id}`
        : `${baseUrl}/tags`;
      const method = id ? "PUT" : "POST";

      const res = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      if (data.status) {
        alert(id ? "Tag updated!" : "Tag added!");
        navigate("/blogs/tags");
      } else {
        alert(data.message || "Something went wrong!");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="side-app">
      <div className="main-container container-fluid">
        {/* PAGE HEADER */}
        <div className="page-header">
          <h1 className="page-title">{id ? "Edit Tag" : "Add Tag"}</h1>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/">Home</a></li>
            <li className="breadcrumb-item active">Tags</li>
          </ol>
        </div>

        {/* FORM */}
        <div className="row">
          <div className="col-xl-12 col-md-12">
            <form className="card" onSubmit={handleSubmit}>
              <div className="card-body">

                {/* Tag Name */}
                <div className="form-group">
                  <label className="form-label">Tag Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>

                {/* Tag Description */}
                <div className="form-group">
                  <label className="form-label">Description</label>
                  <textarea
                    className="form-control"
                    rows={4}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  ></textarea>
                </div>

                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? (id ? "Updating…" : "Saving…") : id ? "Update" : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TagForm;
